import { render } from "./BreastHarmonyForm.vue?vue&type=template&id=3cd5be2c"
import script from "./BreastHarmonyForm.vue?vue&type=script&lang=js"
export * from "./BreastHarmonyForm.vue?vue&type=script&lang=js"

import "./BreastHarmonyForm.vue?vue&type=style&index=0&id=3cd5be2c&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__